import type { MutationFunction, MutationFunctionOptions } from '@apollo/client';
import { useCallback, useRef } from 'react';

export const useMutationWithAbort = (mutation: MutationFunction<any, any>) => {
  const abortControllerRef = useRef(new AbortController());

  const abortLatest = () =>
    abortControllerRef.current && abortControllerRef.current.abort();

  return useCallback(
    async (options: MutationFunctionOptions) => {
      abortLatest();

      const newController = new AbortController();
      abortControllerRef.current = newController;

      return mutation({
        ...options,
        context: {
          fetchOptions: { signal: abortControllerRef.current.signal },
        },
      });
    },
    [mutation],
  );
};
